import { Injector } from '@angular/core';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { TextFilter, RangeDateFilterStore } from '../../../common-page-components/stores/filters-store/filters-store';
import { AthletePhotosStore } from '../../../common-page-components/stores/entities-store/athlete-photos-store';
import { HttpClient } from '@angular/common/http';
import { TeamEntriesStore } from 'src/app/common-page-components/stores/entities-store/team-entries-store';
import { AthletePhotosEventsStore } from '../../../common-page-components/stores/entities-store/athlete-photos-events';
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
import * as i2 from "@angular/common/http";
export class FilterAthletePhotosServiceService {
    constructor(common_filter, http, injector) {
        this.common_filter = common_filter;
        this.http = http;
        this.injector = injector;
        /**
         * The text filter.
         *
         * @memberof FilterAthletePhotosServiceService
         */
        this.textFilter = new TextFilter('text-filter');
        /**
         * The filters of the view.
         *
         * @memberof FilterAthletePhotosServiceService
         */
        this.filterOptions = [];
        /**
         * The store of the athlete photos.
         *
         * @memberof FilterAthletePhotosServiceService
         */
        this.athletePhotoStore = new AthletePhotosStore(this.http);
        /**
         * Team photos entry for get the ahletes of competition in carousel detail.
         *
         * @type {TeamEntriesStore}
         * @memberof FilterAthletePhotosServiceService
         */
        this.photo_team_entries = new TeamEntriesStore(this.http, this.injector);
        this.athletePhotoStore = this.common_filter.athletePhotoStore;
        this.eventsCombo = new AthletePhotosEventsStore('Event:', this.http, this.common_filter.athletePhotoStore.athlete_id);
        this.rangeDate = this.eventsCombo.rangeDate;
        this.eventsCombo.filterInfo.options.initial_state = true;
        this.eventsCombo.filterInfo.options.delay_time = 0;
        this.eventsCombo.athlete_id = this.common_filter.athletePhotoStore.athlete_id;
        this.eventsCombo.requestData({}, false).subscribe();
        this.rangeDate.dateRangeInfo.date_from.intercept_name = 'photos_date_from';
        this.rangeDate.dateRangeInfo.date_to.intercept_name = 'photos_date_to';
        this.rangeDate.dateRangeInfo.date_from.delay_time = 300;
        this.rangeDate.dateRangeInfo.date_to.delay_time = 300;
        this.filterOptions.unshift(this.eventsCombo.filterInfo, this.eventsCombo.rangeDate.filterInfo);
    }
    /**
     * {@inheritdoc}
     *
     * @returns
     * @memberof FilterAthletePhotosServiceService
     */
    getPhotos() {
        return this.common_filter.getPhotos();
    }
    /**
     *
     * A method for load more photos.
     * @param {*} [params] The parameters to send.
     * @memberof FilterAthletePhotosServiceService
     */
    loadMore(params) {
        this.athletePhotoStore.requestData(params, true).subscribe();
    }
    areMoreData() {
        const pagination = this.athletePhotoStore.pagination;
        return pagination.pages > 0 && pagination.next_page !== 0;
    }
    /**
     * Load entries of athlete team.
     *
     * @param {string} compId the competition id.
     * @memberof FilterAthletePhotosServiceService
     */
    loadAthletesEntries(compId) {
        return this.photo_team_entries.requestData({ CompId: compId, Noc: this.common_filter.athleteDetailStore.data[0].NOC }, false);
    }
}
FilterAthletePhotosServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterAthletePhotosServiceService_Factory() { return new FilterAthletePhotosServiceService(i0.ɵɵinject(i1.FiltersAthleteGeneralService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: FilterAthletePhotosServiceService, providedIn: "root" });
